module.exports = __webpack_public_path__ + "static/media/Segoe UI Bold.52382539.woff";